<template>
  <b-modal
    id="add-user-modal"
    v-model="openModal"
    size="lg"
    title="Mise à jour de la base de donnée"
  >
    <GeoserverCreator
      @set="setResource"
    />
    <template #modal-footer>
      <div class="w-100">
        <b-button
          variant="outline-secondary"
          class="float-left"
          @click="cancel"
        >
          {{ $t('buttons.cancel') }}
        </b-button>
        <b-button
          variant="primary"
          class="float-right"
          @click="updateResource"
        >
          {{ $t('buttons.confirm') }}
        </b-button>
      </div>
    </template>
  </b-modal>
</template>

<script>
import GeoserverCreator from '@/components/Resource/creators/GeoserverCreator.vue';

export default {
  name: 'UpdateGeoserverResourceModal',

  components: {
    GeoserverCreator
  },

  props: {
    open: {
      type: Boolean,
      default: false
    }
  },

  data() {
    return {
      openModal: false,
      newResource: null
    };
  },

  watch: {
    open: function(newValue) {
      this.openModal = newValue;
    },
  },

  methods: {
    cancel() {
      this.$emit('hide');
    },

    setResource(e) {
      this.newResource = e;
    },

    updateResource() {
      this.$emit('update', this.newResource);
      this.$emit('hide');
    }
  }
};
</script>

<style lang="less" scoped>

h2 {
  color: @blue;
  margin-top: 0.8em;
  margin-left: 0.5em;
}

p {
  margin-left: 1em;
  font-size: 1.1em;
  font-weight: 500;
}

</style>
